import instance from "./BaseEatAppApi";

export const validateEatApp = (data) => instance.post("validate-credentials/", data);
export const getEatAppStatus = (organisationId) => instance.get("status/", {
  params: { organisation_id: organisationId },
});
export const getEatAppRestaurants = (organisationId, configId) => instance.get("restaurants/", {
  params: { organisation_id: organisationId, config_id: configId },
});
export const saveEatAppMappings = (data) => instance.post("save-mappings/", data);
export const updateEatAppPullSettings = (data) => instance.patch("pull-settings/", data);
export const deactivateEatApp = ({ organisationId, configId }) => instance.delete("deactivate/", {
  data: { organisation_id: organisationId, config_id: configId },
});
export const syncEatApp = ({ organisationId, configId }) => instance.post("sync/", {
  organisation_id: organisationId,
  config_id: configId,
});
